import { render, staticRenderFns } from "./relatedFullStage.vue?vue&type=template&id=fbe09056&scoped=true"
import script from "./relatedFullStage.vue?vue&type=script&lang=ts"
export * from "./relatedFullStage.vue?vue&type=script&lang=ts"
import style0 from "./relatedFullStage.vue?vue&type=style&index=0&id=fbe09056&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe09056",
  null
  
)

export default component.exports